document.addEventListener('turbolinks:load', function () {
  $('.non_deletable_sns_post_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.non_deletable_sns_post_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.non_deletable_sns_post_slidedown_btn').fadeIn(0));
  });

  $('.non_deletable_sns_post_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.non_deletable_sns_post_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.non_deletable_sns_post_slideup_btn').fadeIn(0));
  });

  $(document)
    .off('click', '#search_non_deletable_sns_post_btn')
    .on('click', '#search_non_deletable_sns_post_btn', function () {
      $('.non_deletable_sns_post_list').children().remove();
      const post_val = $('.non_deletable_sns_post_caption').val();

      // テキストエリアから値を取得
      const post_url_val = encodeURIComponent($('.non_deletable_sns_post_caption').val());

      // ベースのURL（現在のページのURLも可能です）
      let baseUrl = $('#non_deletable_sns_post_base_url').val();
      baseUrl = baseUrl + '/non_deletable_sns_post/index';

      // パラメータを追加したURLを構築
      const newUrl = `${baseUrl}?caption=${post_url_val}`;

      // URLの変更（ページはリロードされず、履歴には新しいURLが追加される）
      history.pushState({}, '', newUrl);

      $.ajax({
        url: '/search_non_deletable_sns_post',
        type: 'POST',
        data: {
          caption: post_val,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '1') {
          alert('検索結果のデータ件数が多すぎるためもう少し絞り込んでください。');
        }

        if (data.ret == '2') {
          alert('検索結果が0件でした。条件を変えて再検索してください。');
        }

        if (data.ret == '0' && data.sns_posts.length > 0) {
          data.sns_posts.forEach((post) => {
            console.log(post);
            let postHtml = `
            <div class="non_deletable_sns_post_container relative w-180px mt-1 mr-[2px] mb-1 ml-0">
              <input class="non_deletable_sns_post_check absolute -top-[5px] left-[3px] scale-150" type="checkbox" data-sns_post_id="${post.id}">
              <div class="non_deletable_sns_post_card rounded-md dark:border dark:border-gray-800">
                <a href="${post.permalink}" target="_blank">
                  ${generateMediaContent(post, data.s3_base_url)}
                </a>
                <div class="non_deletable_sns_post_content h-100px pt-2 px-5 pb-5">
                  <div class="non_deletable_sns_post_content_text text-[11px] h-[86px] m-0 text-gray-500">
                    ${post.caption.length > 40 ? `${post.caption.substring(0, 40)}...` : post.caption}
                  </div>
                </div>
              </div>
            </div>
          `;
            $('.non_deletable_sns_post_list').append(postHtml);
          });

          $('.non_deletable_sns_post_check').on('change', function () {
            if ($(this).is(':checked')) {
              let sns_post_id = $(this).data('sns_post_id');
              $.ajax({
                url: '/relate_non_deletable_sns_post',
                type: 'POST',
                data: {
                  sns_post_id: sns_post_id,
                },
                dataType: 'json',
              }).done(function (data) {
                location.reload();
              });
            }
          });
        }
      });
    });

  $('.non_deletable_sns_post_check').on('change', function () {
    if ($(this).is(':checked')) {
      let sns_post_id = $(this).data('sns_post_id');
      $.ajax({
        url: '/relate_non_deletable_sns_post',
        type: 'POST',
        data: {
          sns_post_id: sns_post_id,
        },
        dataType: 'json',
      }).done(function (data) {
        location.reload();
      });
    }
  });

  function generateMediaContent(post, s3_base_url) {
    const account_id = post.account_id.toString().padStart(5, '0');
    const created_at_date = new Date(post.created_at);
    created_at_date.setHours(created_at_date.getHours() + 9);
    const created_at = created_at_date.toISOString().split('T')[0];

    switch (post.post_type) {
      case 0:
        post_type_name = 'top';
        break;
      case 1:
        post_type_name = 'rec';
        break;
      default:
        post_type_name = 'myp';
    }

    let mediaContent = '';
    if (post.media_type === 'VIDEO' || (post.media_type === 'CAROUSEL_ALBUM' && post.media_url.includes('mp4'))) {
      mediaContent = `<video loop autoplay muted playsinline class="post_tag_card_img" src="${s3_base_url}/ig_hashtag_media/videos/${post_type_name}_ac${account_id}_${post.media_id}_${created_at}.mp4" alt=""></video>`;
    } else if (post.media_type === 'MANUAL_OWN_POST' && post.my_post_media_order_media_type === 'IMAGE') {
      mediaContent = `<img class="post_tag_card_img" src="${s3_base_url}/ig_hashtag_media/pictures/${post.my_post_media_order_file_name}" alt="">`;
    } else if (post.media_type === 'MANUAL_OWN_POST' && post.my_post_media_order_media_type === 'VIDEO') {
      mediaContent = `<video loop autoplay muted playsinline class="post_tag_card_img" src="${post.original_file_name ? s3_base_url + '/ig_hashtag_media/videos/' + post.my_post_media_order_file_name : post.media_url}" alt=""></video>`;
    } else {
      mediaContent = `<img class="post_tag_card_img" src="${s3_base_url}/ig_hashtag_media/pictures/${post_type_name}_ac${account_id}_${post.media_id}_${created_at}.jpg" alt="">`;
    }
    return mediaContent;
  }

  $('.related_non_deletable_sns_post_delete_submit_btn')
    .off()
    .on('click', function (event) {
      let sns_post_id = $(this).data('sns_post_id');
      $.ajax({
        url: '/delete_non_deletable_sns_post',
        type: 'POST',
        data: {
          sns_post_id: sns_post_id,
        },
        dataType: 'json',
      }).done(function (data) {
        location.reload();
      });
    });
});
